export function stripDiacritics(str: string): string {
  return typeof str.normalize !== "undefined"
    ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    : str;
}
